import {createApp} from 'vue';
import QuickScan from './QuickScan.vue';

if(document.getElementById('quick-scan-app')) {
    const mountEl = document.getElementById('quick-scan-app');
    const app     = createApp({
        components: {
            QuickScan
        }
    });
    app.mount(mountEl);
}